import {
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';

import useLocales from '@src/locales/use-locales';

import Iconify from '../iconify';

const LanguageSelector = () => {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const filteredLang = allLangs.filter((lang) => lang.value !== 'el');

  const handleChange = (event: SelectChangeEvent) => {
    onChangeLang(event.target.value);
  };

  return (
    <Select
      value={currentLang.value ?? 'en'}
      onChange={handleChange}
      variant="standard"
      color="primary"
      displayEmpty
      renderValue={() => {
        return (
          <Stack direction="row" sx={{ gap: 1 }}>
            <Iconify icon={currentLang.icon} />
            {currentLang.label}
          </Stack>
        );
      }}
    >
      {filteredLang.map((lang) => {
        return (
          <MenuItem
            value={lang.value}
            key={lang.label}
            sx={{ display: 'flex', gap: 1 }}
          >
            <Iconify icon={lang.icon} />
            <Typography variant="body1">{lang.label}</Typography>
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default LanguageSelector;
